import Translate from "../../translate/Translate";
import { CustomMultiFilterButton } from "../button/CustomMultiFilterButton";

export default function PaymentFilterButton({ currentValues, setValues }) {
    const values = [
        { label: Translate("revenue.paymentMethod.allPayment"), value: "all" },
        { label: Translate("revenue.paymentMethod.coin"), value: "Coin" },
        { label: Translate("revenue.paymentMethod.truemoney"), value: "Truemoney" },
        { label: Translate("revenue.paymentMethod.creditCard"), value: "Credit Card" },
        { label: Translate("revenue.paymentMethod.shopeepay"), value: "Shopee Pay" },
        { label: Translate("revenue.paymentMethod.line"), value: "Line" },
        { label: Translate("revenue.paymentMethod.promptPay"), value: "Prompt Pay" },
    ];

    return (
        <CustomMultiFilterButton
            icon={currentValues.includes("all") ? "wallet" : "wallet_active"}
            currentValues={currentValues}
            setValues={setValues}
            values={values}
            multiText={"Payment"}
            iconWidth={"12.3px"}
            iconHeight={"12px"}
        />
    );
}
